import { useEffect } from 'react';

export function useApplyViewPermissions(permissions: Record<string, boolean>) {
  const applyPermission = (permission: string, hide: boolean) => {
    const elements = document.querySelectorAll(
      `[data-permission="${permission}"]`,
    );
    if (elements?.length) {
      elements.forEach((e) => {
        const overrideDefaultAction =
          e.getAttribute('data-permission-action-override') ||
          (hide ? 'hide' : 'show');
        switch (overrideDefaultAction) {
          case 'hide':
            (e as HTMLElement).style.display = 'none';
            break;
          case 'show':
            (e as HTMLElement).style.display = '';
            break;
        }
      });
    }
  };

  useEffect(() => {
    if (!permissions || Object.keys(permissions).length === 0) {
      return;
    }
    Object.keys(permissions).forEach((permission) => {
      applyPermission(permission, !permissions[permission]);
    });
  }, [permissions]);
}
